import React, { useEffect } from 'react';
import Navbar from './Navbar';
import HeroContent from './HeroContent';
import SolarSystem from './SolarSystem';
import Partners from './Partners';
import ProductTour from './ProductTour';
import Services from './Services';
import Pricing from './Pricing';
import ContactSection from './ContactSection';
import Footer from './Footer';
import Testimonials from './Testimonials';

function App() {
  // The demo lives on its own page (vetobase.com/watch) and opens in a new tab.
  const openFilm = () => window.open('/watch/', '_blank', 'noopener');
  // Old shared links (vetobase.com/#watch) forward to the demo page.
  useEffect(() => { if (window.location.hash === '#watch') window.location.replace('/watch/'); }, []);

  return (
    <div className="min-h-screen bg-paper mesh-gradient overflow-x-hidden selection:bg-ink selection:text-paper">
      <Navbar />

      <main className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-16 pt-24 pb-20 md:pt-44 md:pb-32">
        <section className="flex-1 w-full">
          <HeroContent onWatch={openFilm} />
        </section>

        <section className="flex flex-1 w-full justify-center mt-8 md:mt-0">
          <div className="relative aspect-square w-full max-w-[300px] sm:max-w-[380px] md:max-w-[460px] lg:max-w-[520px] xl:max-w-[560px] mx-auto">
            <SolarSystem />
          </div>
        </section>
      </main>

      <Partners />
      <ProductTour onWatch={openFilm} />
      <Services />
      <Pricing />
      <ContactSection />
      <Testimonials />
      <Footer />
    </div>
  );
}

export default App;
